class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    if (!this.form || !this.submitButton) return;
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.submitButton.setAttribute('aria-disabled', 'true');
    this.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append('sections', 'cart-icon-bubble');
    config.body = formData;

    try {
      const response = await fetch(routes.cart_add_url, config);
      const item = await response.json();

      if (item.status) {
        this.#showError(item.description || item.message);
        return;
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && item.sections?.['cart-icon-bubble']) {
        const newBubble = new DOMParser()
          .parseFromString(item.sections['cart-icon-bubble'], 'text/html')
          .getElementById('cart-icon-bubble');
        if (newBubble) {
          bubble.innerHTML = newBubble.innerHTML;
          bubble.className = newBubble.className;
          bubble.classList.add('is-visible');
        }
      }

      // Dispatch first: this closes the quick-add modal, and the notification is
      // non-modal, so it would sit behind that modal's backdrop otherwise.
      this.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { item } }));

      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) {
        customElements.whenDefined('cart-notification').then(() => {
          cartNotification.notify(item);
        });
      }
    } catch (error) {
      this.#showError();
    } finally {
      this.submitButton.removeAttribute('aria-disabled');
      this.classList.remove('loading');
    }
  }

  #showError(message) {
    const formWrapper = this.closest('.product-form');
    if (!formWrapper) return;

    let el = formWrapper.querySelector('.product-form__error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'product-form__error';
      formWrapper.appendChild(el);
    }
    el.textContent = message || this.dataset.cartError;

    clearTimeout(this.errorTimeout);
    this.errorTimeout = setTimeout(() => el.remove(), 4000);
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
